<template>
	<div class="order-goods-div">
		<div class="" v-if="orderDetail.orderType == 1">
			<van-row v-for="(item,index) in orderDetail.starSubOrders" :key="index">
				<van-col span="8">
					<img class="order-goods-image" :src="item.thumb" />
				</van-col>
				<van-col span="12">
					<div class="order-goods-name">{{item.goodsName}}</div>
					<div class="order-goods-specification">{{item.goodsSpec}}</div>
					<div class="order-goods-price">
						<span>¥</span>
						<span>{{item.goodsEndPrice}}</span>
					</div>
					<div class="order-code-context">取单口令：{{item.takeFoodCode}}</div>
				</van-col>
				<van-col span="4">
					<div class="order-goods-count">x{{item.goodsNum}}</div>
				</van-col>
			</van-row>
			<div class="divider-div"></div>
			<van-row type="flex" justify="space-between">
				<van-col span="8">
					<div class="order-save-money">
						已省：¥{{parseFloat(orderDetail.officialTotalAmount - orderDetail.orderAmount).toFixed(2)}}</div>
				</van-col>
				<van-col span="16">
					<div class="order-money">
						<span>共一件，实付：</span>
						<span>¥</span>
						<span>{{orderDetail.orderAmount}}</span>
						<span>¥{{orderDetail.officialTotalAmount}}</span>
					</div>
				</van-col>
			</van-row>
		</div>


		<div v-if="orderDetail.orderType == 2" class="order-box-2">
			<div class="order-box-2-top">
				<div class="order-name">星巴克中杯全国通兑券</div>
				<div class="order-num">订单编号：{{orderDetail.orderNo}}</div>
				<div class="order-time">订单时间：{{orderDetail.createdTime}}</div>
				<div class="order-hint">质保日期：<span>购买后次日10点前有效</span></div>

			</div>
			<div class="order-img">
				<img src="../../assets/875e3e8cdeedd519c868a4286a238dd.png" v-if="orderDetail.productExpireFlag == 1" style="width: 60%;">
				<img v-else :src="orderDetail.productCode">
			</div>
			<div class="order-box-2-bottom">
				<div class="order-head-text">—— 使用须知 ——</div>
				<!-- <div class="order-text">{{
					orderDetail.productMsg
				}}</div> -->
				<div class="order-text">
					<p>1.<span style="color: red;">卡券有效期为购买后至次日上午10:00</span>，请于有效期前使核用，如扫码销失败后可以提供二维码数字券码供店员核销。</p>
					<p>2.到店出示卡券由门店机具扫描验证后即可兑换。星巴克全国指定直营门店可用（臻选店，机场店，火车站等交通枢纽和景区门店除外）。</p>
					<p>
						3.星巴克中杯饮品电子券适用于中国大陆地区指定星巴克门店对外销售的现场手工调制标准配方(中杯355ml，非定制)饮品(不包括瓶装饮料、星巴克臻选咖啡系列、星巴克气致冷萃咖啡、虹吸壶冲泡咖啡和咖啡融合冰淇淋系列等部分特定饮品，详询星巴克店员)
					</p>
					<p>4.使用如遇问题请联系客服：<a href="tel:4001870118" class="call">4001870118</a>（9:00-21:00）</p>
				</div>
			</div>


		</div>
	</div>

</template>

<script>
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	import {
		Col,
		Row
	} from 'vant';
	export default {
		name: 'OrderGoods',
		components: {
			[Col.name]: Col,
			[Row.name]: Row

		},
		props: ['orderDetail'],
		data() {
			return {}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.order-goods-div {
		border-radius: 5px;
		padding: 10px;
		background-color: #ffffff;
	}


	.order-goods-image {
		width: 90px;
		height: 90px;
		display: block;
		margin: 0 auto;
	}

	.order-goods-name {
		padding-bottom: 5px;
		color: #343434;
		font-size: 17px;
		font-weight: 650;
	}

	.order-goods-specification {
		padding-bottom: 3px;
		color: #656565;
		font: 14px;
	}

	.order-goods-price>span:first-child {
		color: #c8544a;
		font-size: 14px;
		font-weight: 570;
	}

	.order-code-context {
		font-size: 14px;
		line-height: 20px;
		font-weight: 550;
		color: red;
	}

	.order-goods-price>span:last-child {
		color: #c8544a;
		font-size: 16px;
		font-weight: 570;
	}

	.divider-div {
		width: 100%;
		height: 1px;
		border-top: #dedede 1px dashed;
		padding: 5px;
	}

	.order-goods-count {
		font-size: 15px;
		color: #343434;
		text-align: right;
		padding-top: 30px;
		font-weight: 600;

	}

	.order-save-money {
		font-size: 15px;
		color: #414141;
		font-weight: 500;
		padding-left: 5px;
	}

	.order-money {
		padding-right: 5px;
		text-align: right;
	}

	.order-money>span:nth-child(1) {
		font-size: 15px;
		color: #414141;
		font-weight: 500;
	}

	.order-money>span:nth-child(2) {
		font-size: 13px;
		color: #cf4645;
		font-weight: 550;

	}

	.order-money>span:nth-child(3) {
		font-size: 16px;
		color: #cf4645;
		font-weight: 550;

	}

	.order-money>span:nth-child(4) {
		font-size: 13px;
		color: #959394;
		text-decoration: line-through;
		margin-left: 3px;
	}

	.order-box-2 {
		width: 100%;
		display: flex;
		flex-direction: column;
		color: #656565;
		padding: 15px 0;
		/* justify-content: center; */
		/* text-align: center; */
	}

	.order-box-2-top {
		padding: 0 60px;
	}

	.order-name {
		font-size: 16px;
		color: #000000;
		font-weight: bold;

	}

	.order-name,
	.order-num,
	.order-time {
		margin-bottom: 2px;
	}

	.order-img {
		margin: 20px 0;
		width: 100%;
		text-align: center;
	}

	.order-img img {
		width: 100%;
		/* height: 300px; */
	}

	.order-hint span {
		color: red;
	}

	.order-text {
		word-wrap: break-word;
		overflow: hidden;
	}

	.order-head-text {
		font-size: 16px;
		text-align: center;
		color: #333333;
		font-weight: bold;
		margin-bottom: 5px;
		padding: 0 60px;
	}
</style>
